import { Grid, Text, Title } from "@mantine/core";
import { joiResolver, useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { BusinessTypes } from "../../../enums/business-type";
import BusinessTypeButton from "../../buttons/business-type.button/business-type.button";
import StepperButton from "../../buttons/stepper.button/stepper.button";
import {
  BuildingSkyscraper,
  BuildingStore,
  User,
  Users,
} from "tabler-icons-react";
import { BusinessTypeSchema } from "../../../schemas/business-type.schema";
import { UseFormReturnType } from "@mantine/form/lib/use-form";
import { MerchantOnboardingFormValues } from "../../../type/merchant-onboarding-form-values.types";

interface BusinessTypeStepProps {
  mainForm: UseFormReturnType<MerchantOnboardingFormValues>;
  active: number;
  activated: boolean;
  nextStep: () => void;
  prevStep: () => void;
}
function BusinessTypeStep(props: BusinessTypeStepProps) {
  const { mainForm, active, activated, nextStep, prevStep } = props;
  const [loading, setLoading] = useState(false);
  const [clicked, setClicked] = useState(BusinessTypes.STARTER);
  const form = useForm({
    initialValues: mainForm.values,
    schema: joiResolver(BusinessTypeSchema),
  });

  useEffect(() => {
    if (!activated) {
      return;
    }
    form.setValues(mainForm.values);
  }, [active]);

  useEffect(() => {
    form.setFieldValue("businessTypeId", clicked);
  }, [clicked]);

  const handleNextStep = () => {
    setLoading(true);
    mainForm.setValues(form.values);
    setLoading(false);
    if (!loading) nextStep();
  };

  const handlePrevStep = () => {
    setLoading(true);
    mainForm.setValues(form.values);
    form.clearErrors();
    setLoading(false);
    if (!loading) prevStep();
  };

  return (
    <>
      {form.errors.businessTypeId}
      <form onSubmit={form.onSubmit(handleNextStep)}>
        <Grid mb={15}>
          <Grid.Col>
            <Title order={1}>Business Information</Title>
          </Grid.Col>
          <Grid.Col>
            <Title
              order={2}
              style={{ fontWeight: 400 }}
              data-cy="businessTypeTitle"
            >
              Type of Business
            </Title>
          </Grid.Col>
          <Grid.Col>
            <Text color="grey">
              What is your type of business? <br />
              The next questions we will ask you will be based on your business
              type.
            </Text>
          </Grid.Col>
          <Grid.Col span={12}>
            <BusinessTypeButton
              name="Starter business"
              clicked={clicked === BusinessTypes.STARTER ? true : false}
              setClicked={setClicked}
              value={BusinessTypes.STARTER}
              icon={<BuildingStore size={100} className="button-icon" />}
            ></BusinessTypeButton>
          </Grid.Col>
          <Grid.Col>
            <BusinessTypeButton
              name="Sole Proprietor"
              clicked={clicked === BusinessTypes.SOLE_PROPRIETOR ? true : false}
              setClicked={setClicked}
              value={BusinessTypes.SOLE_PROPRIETOR}
              icon={<User size={100} className="button-icon" />}
            ></BusinessTypeButton>
          </Grid.Col>
          <Grid.Col>
            <BusinessTypeButton
              name="Partnership"
              clicked={clicked === BusinessTypes.PARTNERSHIP ? true : false}
              setClicked={setClicked}
              value={BusinessTypes.PARTNERSHIP}
              icon={<Users size={100} className="button-icon" />}
            ></BusinessTypeButton>
          </Grid.Col>
          <Grid.Col>
            <BusinessTypeButton
              name="Corporation"
              clicked={clicked === BusinessTypes.CORPORATION ? true : false}
              setClicked={setClicked}
              value={BusinessTypes.CORPORATION}
              icon={<BuildingSkyscraper size={100} className="button-icon" />}
            ></BusinessTypeButton>
          </Grid.Col>
        </Grid>
        <StepperButton
          prevStep={handlePrevStep}
          active={active}
          submit
          nextStep={undefined}
          loading={loading}
        />
      </form>
    </>
  );
}

export default BusinessTypeStep;
